import { createSlice } from '@reduxjs/toolkit'

export const modalsStore = createSlice({
    name: 'modals-store',
    initialState: {
        openLoadingModalState: false,
        openLoginModalState: false,
        openconnectModalState: false,
        openDisconnectModalState: false
    },
    reducers: {
        // loading弹框
        setLoadingModal: (state, action) => {
            state.openLoadingModalState = action.payload
        },
        // 登录弹框
        setLoginModal: (state, action) => {
            state.openLoginModalState = action.payload
        },
        // 连接小车弹框
        setConnectModal: (state, action) => {
            state.openconnectModalState = action.payload
        },
        // 断开小车弹框
        setDisconnectModal: (state, action) => {
            state.openDisconnectModalState = action.payload
        },
    }
})

export const {
    setLoadingModal,
    setLoginModal,
    setConnectModal,
    setDisconnectModal
} = modalsStore.actions
export default modalsStore.reducer